import { CONTAINER_TEXT_COLORS, CONTAINER_TEXT_COLOR_OPTIONS, INHERIT_COLOR } from '../container-colors';
import { createCustomColorField } from './custom-color-field';

/**
 * Returns true for values that map to a named option (inherit or a CONTAINER_TEXT_COLORS key).
 * A hex or unknown value is treated as custom.
 */
function isNamedOption(value: string): boolean {
  if (value === INHERIT_COLOR) return true;
  return Object.prototype.hasOwnProperty.call(CONTAINER_TEXT_COLORS, value);
}

/**
 * Puck custom field for a container's text color override.
 *
 * Offers the named container text color roles (Inherit, Secondary, Muted, Inverted) plus a custom
 * hex escape hatch. The stored value is either `INHERIT_COLOR`, a `CONTAINER_TEXT_COLORS` key, or a
 * hex string. Resolved at render time via `containerColorStyle`.
 *
 * Deliberately excludes the `text` role, mirroring `CONTAINER_TEXT_COLORS` — that role resolves to
 * `--dcm-color-text-primary`, which is the very property this override writes, so choosing it would
 * make the custom property reference itself.
 */
export const ContainerTextColorField = createCustomColorField({
  options: CONTAINER_TEXT_COLOR_OPTIONS,
  testIdPrefix: 'container-text-color',
  cssPrefix: '--dcm-cms-container-text-color',
  customDefault: '#ffffff',
  isNamedOption,
  defaultValue: INHERIT_COLOR,
});
